<template>
    <div class="b2b-checkout-wrapper billing-wrapper">
        <Success v-if="is_dealer" :order="props.order"/>
        <D2CCheckoutSuccessPage v-else :order="props.order" :order_user="props.order_user" :user_key="props.user_key" />
    </div>
</template>
<script setup lang="ts">
    import Success from "@/Pages/DealerCheckout/Success.vue";
    import D2CCheckoutSuccessPage from "@/Pages/D2CCheckoutSuccessPage.vue";
    import { useSettingsStore } from "@/store/settings.ts";
    import { storeToRefs } from "pinia";

    const props = defineProps({
        order: {
            type: Object,
            default(){
                return {}
            }
        },
        user: {
            type: Object,
            default(){
                return {};
            }
        },
        order_user: {
            type: Object,
            default(){
                return {};
            }
        },
        user_key: {
            type: [String, Number],
            default: null
        },
    })

    let settings = useSettingsStore();
    const { is_dealer } = storeToRefs(settings);
</script>